import { GET_PAYOUTS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    payouts: Payout[];
    latestPayoutAmount: number;
}

export interface Payout {
    payout_id: string;
    is_system: string;
    amount: number;
    tds: number;
    net_earning: number;
    status: string;
    utr: string;
    mode: string;
    purpose: string;
    orders: Order[];
    error: string;
    created_at: string;
    account_details: AccountDetails;
    rowspan?: number;
}

export interface Order {
    order_id: string;
}

export interface AccountDetails {
    account_type: string;
    account_number: string;
    address: string;
}

export default (isForDoctor?: boolean): Promise<Response> => {
    return fetchWithRefresh(GET_PAYOUTS(isForDoctor)).then((res) => res.json());
};
